import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../../components/router/router-tabbed-navigation';
import { MfRecoPositionDaysTable } from '../../../../../../../../../../../features/mutual-funds/reconciliation/position-day/mfreco-position-days-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsMutualfunds,
      label: 'Position Days',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsMutualfunds>,
  head: () => getPageHead('Mutual Funds Position Days'),
  component: MfRecoPositionDaysList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsMutualfunds}
    />
  );
}

function MfRecoPositionDaysList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <MfRecoPositionDaysTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
